<script>
  import { Input } from 'element-ui'

  const percentRegex = /^(?:[1-9]|[1-9][0-9]|100)$/

  export default {
    name: 'MgInput',
    extends: Input,
    props: {
      fixed: {
        type: Number,
        default: 2,
      },

      limitCount:{
        type:Number,
        default:-1,
      },

      // 当输入框被清空时显示的值
      valueOnClear: {
        type: Number,
        default: null,
      },

      // focus 时是否选中内容
      isSelectOnFocus: {
        type: Boolean,
        default: false,
      },
      // 允许负数
      allowNegative: {
        type: Boolean,
        default: false,
      },
      // 新增prop：限制小数点前的最大整数位数，null表示不限制
      maxIntegerDigits: {
        type: Number,
        default: null,
      },
    },
    computed: {
      AmountRegExp() {
        if (this.fixed <= 0) return new RegExp(`^${this.allowNegative ? '-?' : ''}\\d*$`)
        return new RegExp(`^${this.allowNegative ? '-?' : ''}\\d*\\.?\\d{0,${this.fixed}}$`)
      },
    },
    methods: {
      handleInput(event) {
        if (this.isComposing) return

        // 把中文句号替换为英文点号
        if (event.target.value && event.target.value.includes('。')) {
          event.target.value = event.target.value.replace(/。/g, '.')
        }

        if (this.type === 'float') {
          // 浮点数不能以以下字符开头
          if (['.', '-.', '+'].includes(event.target.value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 只能输入负号、小数点和数字，且-和.只能输入一次
          if (!this.AmountRegExp.test(event.target.value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 禁止输入 (-)00 或 (-)012 形式的浮点数
          if (/^-?0\d+/.test(event.target.value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 新增校验：检查整数部分长度
          if (this.maxIntegerDigits != null) {
            const value = event.target.value
            if (value) {
              let [integerPart] = value.split('.')
              if (this.allowNegative) {
                integerPart = integerPart.replace(/^-/, '') // 移除负号
              }
              if (integerPart.length > this.maxIntegerDigits) {
                this.$nextTick(this.setNativeInputValue)
                return
              }
            }
          }
        }

        if (this.type === 'percent') {
          if (event.target.value.trim() && !percentRegex.test(event.target.value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }
        }

        //只能输入整数
        if (this.type === 'integer') {
          const value = event.target.value

          // 1. 禁止以以下字符开头
          if (['.', '-.', '+.'].includes(value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 2. 只能输入负号和数字，且负号只能出现一次且在开头
          const integerRegex = this.allowNegative ? /^-?\d*$/ : /^\d*$/
          if (!integerRegex.test(value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 3. 禁止输入 (-)0 后面跟其他数字（防止前导零）
          if (/^-?0\d+/.test(value)) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 4. 负号只能在开头且只能有一个
          if ((value.match(/-/g) || []).length > 1) {
            this.$nextTick(this.setNativeInputValue)
            return
          }
          if (value.includes('-') && !value.startsWith('-')) {
            this.$nextTick(this.setNativeInputValue)
            return
          }

          // 5. 校验整数部分长度限制
          if (this.maxIntegerDigits != null) {
            let integerPart = value
            if (this.allowNegative) {
              integerPart = integerPart.replace(/^-/, '') // 移除负号
            }
            if (integerPart.length > this.maxIntegerDigits) {
              this.$nextTick(this.setNativeInputValue)
              return
            }
          }

          // 6. 新增：校验limitCount限制
          if (this.limitCount > 0) {
            let integerPart = value
            if (this.allowNegative) {
              integerPart = integerPart.replace(/^-/, '') // 移除负号
            }
            if (integerPart.length > this.limitCount) {
              this.$nextTick(this.setNativeInputValue)
              return
            }
          }
        }
        //只能输入整数

        if (
          typeof this.valueOnClear === 'number' &&
          (event.target.value === '' || event.target.value === null || event.target.value === undefined)
        ) {
          event.target.value = this.valueOnClear
        }

        if (event.target.value === this.nativeInputValue) return

        this.$emit('input', event.target.value)

        this.$nextTick(this.setNativeInputValue)
      },

      handleFocus(event) {
        this.focused = true
        if (this.isSelectOnFocus) event.currentTarget.select()
        this.$emit('focus', event)
      },
    },
  }
</script>
